<template>
  <div class="share_box">
    <el-breadcrumb separator="|">
      <el-breadcrumb-item class="my_icon_box" :class="detail.is_like === 1 ? 'act' : ''">
        <a @click="doLike(detail.list_id, detail.is_like)">
          <i class="my_icon dianzan"></i>
          <span v-if="detail.like === 0" class="my_icon_text">点赞</span>
          <span v-else class="my_icon_text">
            <b v-if="detail.is_like === 0">点赞</b>
            <b v-if="detail.is_like === 1">已点赞</b>
            {{detail.like}}
          </span>
        </a>
      </el-breadcrumb-item>
      <el-breadcrumb-item class="my_icon_box" :class="detail.is_collection === 1 ? 'act' : ''">
        <a @click="doFavorite(detail.list_id, detail.is_collection)">
          <i class="my_icon shoucang"></i>
          <span v-if="detail.favorites === 0" class="my_icon_text">收藏</span>
          <span v-else class="my_icon_text">
            <b v-if="detail.is_like === 0">收藏</b>
            <b v-if="detail.is_like === 1">已收藏</b>
            {{detail.favorites}}
          </span>
        </a>
      </el-breadcrumb-item>
      <el-breadcrumb-item class="my_icon_box">
        <el-popover
          placement="bottom"
          width="305"
          trigger="click"
          @show = 'creatCode()'>
          <div class="detail_share_box">
            <div class="detail_share_left lf">
              <div class="detail_share_left_img">
                <img id="qr-img" :src="dataUrl" alt="邀请二维码">
              </div>
              <div class="detail_share_left_text">
                微信“<span>扫一扫</span>” <br> 分享给好友
              </div>
            </div>
            <div class="detail_share_hr lf"></div>
            <ul class="detail_share_right lf">
              <li>
                <a @click="handleCommand('weibo')">
                  <i class="iconfont icon-weibo"></i>分享到微博
                </a>
              </li>
              <li>
                <a @click="handleCommand('qqHY')">
                  <i class="iconfont icon-qq"></i>分享到QQ
                </a>
              </li>
            </ul>
          </div>
          <a type="primary" slot="reference">
            <i class="my_icon fenxiang"></i>
            <span v-if="detail.share === 0" class="my_icon_text">分享</span>
            <span v-else class="my_icon_text">{{detail.share}}</span>
          </a>
        </el-popover>
      </el-breadcrumb-item>
      <el-breadcrumb-item class="my_icon_box r_border">
        <a @click="reportLayer = true">
          <i class="my_icon jubao"></i>
          <span class="my_icon_text">举报</span>
        </a>
      </el-breadcrumb-item>
      <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 举报弹窗 -->
    <el-dialog title="举报信息" :visible.sync="reportLayer" width="400px">
      <el-form :model='report'>
        <el-form-item label="举报类别" label-width='80px'>
          <el-select v-model="report.type" placeholder="请选择举报类别">
            <el-option label="垃圾广告" value="垃圾广告"></el-option>
            <el-option label="辱骂人身攻击等不友善行为" value="辱骂人身攻击等不友善行为"></el-option>
            <el-option label="涉政" value="涉政"></el-option>
            <el-option label="其它原因" value="其它原因"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reportLayer = false">取 消</el-button>
        <el-button type="primary" @click="reportMesConfirm(detail.list_id)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcode' // 引入网页二维码生成器
export default {
  name: 'Share',
  props: {
    detail: { required: true }
  },
  data () {
    return {
      dataUrl: '', // 当前页面地址
      reportLayer: false, // 举报弹窗
      report: { // 举报类别
        list_id: '',
        type: '' // 举报信息类别
      }
    }
  },
  methods: {
    // 文章点赞
    doLike (rid, like) {
      const vueThat = this
      if (like === 0) {
        vueThat.myApi.doLike({ list_id: vueThat.detail.list_id }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '点赞成功！',
            //   type: 'success'
            // })
            vueThat.detail.is_like = 1
            vueThat.detail.like += 1
          }
        })
      } else {
        vueThat.myApi.cancelLike({ list_id: vueThat.detail.list_id }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '取消点赞成功！',
            //   type: 'success'
            // })
            vueThat.detail.is_like = 0
            vueThat.detail.like -= 1
          }
        })
      }
    },
    // 文章收藏功能
    doFavorite (rid, collection) {
      const vueThat = this
      if (collection === 0) {
        vueThat.myApi.doFavorite({ list_id: vueThat.detail.list_id }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '收藏成功！',
            //   type: 'success'
            // })
            vueThat.detail.is_collection = 1
            vueThat.detail.favorites += 1
          }
        })
      } else {
        vueThat.myApi.cancelFavorite({ list_id: vueThat.detail.list_id }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '取消收藏成功！',
            //   type: 'success'
            // })
            vueThat.detail.is_collection = 0
            vueThat.detail.favorites -= 1
          }
        })
      }
    },
    // 生成页面二维码
    creatCode () {
      const img = document.getElementById('qr-img')
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      // 用 canvas 对象和邀请链接生成二维码，并将生成的二维码转为 base64
      QRCode.toCanvas(canvas, window.location.href, (error) => {
        if (error) {
          console.log(error)
        } else {
          this.dataUrl = canvas.toDataURL('image/jpeg')// 点击第一次展开
        }
      })
    },
    // 分享
    handleCommand (command) {
      const vueThat = this
      const currentUrl = window.location.href
      let url = ''
      switch (command) {
        case 'weibo':
          url = `http://service.weibo.com/share/share.php?url=${currentUrl}?sharesource=weibo&title=${this.detail.title}&pic=图片&appkey=3265476805`
          window.open(url, '_blank')
          break
        case 'qqKJ':
          url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${currentUrl}?sharesource=qzone&title=${this.detail.title}&pics=图片&summary=分享描述信息`
          window.open(url, '_blank')
          break
        case 'qqHY':
          url = `http://connect.qq.com/widget/shareqq/index.html?url=${currentUrl}?sharesource=qzone&title=${this.detail.title}&pics=你的分享图片地址&summary=你的分享描述&desc=你的分享简述`
          window.open(url, '_blank')
          break
        case 'weixin':
          url = `http://connect.qq.com/widget/shareqq/index.html?url=${currentUrl}?sharesource=qzone&title=${this.detail.title}&pics=你的分享图片地址&summary=你的分享描述&desc=你的分享简述`
          window.open(url, '_blank')
          break
      }
      this.myApi.addShare({ list_id: this.detail.list_id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.detail.share++
        }
      })
    },
    // 举报确认按钮
    reportMesConfirm (id) {
      const vueThat = this
      vueThat.report.list_id = id
      vueThat.myApi.report(vueThat.report).then((res) => {
        if (res.data.code === 200) {
          vueThat.reportLayer = false
          vueThat.$message({
            message: '举报信息提交成功！',
            type: 'success'
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
